<app-portal-modal-shell
  [title]="title"
  [size]="size"
  [busy]="busy"
  [dismissible]="!busy"
  [showOverlay]="false"
  (dismiss)="dismiss()">
  <p class="mb-0 text-gray-700" *ngIf="message">{{ message }}</p>
  <dl class="portal-confirm-fields mb-0" [class.mt-3]="!!message" *ngIf="fields.length">
    <div class="portal-confirm-fields__row" *ngFor="let field of fields" [class.portal-confirm-fields__row--edit]="field.editable">
      <dt>{{ field.label }}</dt>
      <dd *ngIf="!field.editable">{{ field.value }}</dd>
      <dd *ngIf="field.editable && isCheckbox(field)">
        <app-portal-switch
          size="sm"
          [checked]="fieldValue(field) === '1'"
          [disabled]="busy"
          [label]="field.hint || field.label"
          [ariaLabel]="field.label"
          (changed)="onCheckboxChange(field, $event)">
        </app-portal-switch>
      </dd>
      <dd *ngIf="field.editable && !isCheckbox(field)">
        <input
          class="form-control form-control-sm"
          [type]="field.type === 'email' ? 'email' : 'text'"
          [placeholder]="field.placeholder || ''"
          [ngModel]="fieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          [disabled]="busy"
          [attr.aria-label]="field.label"
          [attr.required]="field.required ? true : null" />
        <div class="text-muted fs-8 mt-1" *ngIf="field.hint">{{ field.hint }}</div>
      </dd>
    </div>
  </dl>
  <div class="text-danger fs-8 mt-2" *ngIf="fieldError">
    {{ 'COMMON.FIELD_REQUIRED' | translate:{ field: fieldError } }}
  </div>
  <div class="text-danger fs-8 mt-2" *ngIf="fieldErrorKey">
    {{ fieldErrorKey | translate }}
  </div>
  <div portalModalFooter class="d-flex justify-content-end flex-wrap gap-2 w-100">
    <app-portal-button
      layout="label"
      variant="light"
      [disabled]="busy"
      (pressed)="dismiss()">
      {{ cancelLabel || ('COMMON.CANCEL' | translate) }}
    </app-portal-button>
    <app-portal-button
      layout="label"
      [variant]="confirmVariant"
      [loading]="busy"
      [disabled]="busy"
      (pressed)="confirm()">
      {{ confirmLabel || ('COMMON.CONFIRM' | translate) }}
    </app-portal-button>
  </div>
</app-portal-modal-shell>
